import React from "react";
import { withRouter } from "react-router-dom";
import Language from "../language/language";
import { inject, observer } from "mobx-react";
import { Form, Input, Button, Select, Cascader, message } from "antd";
import agent from "../../agent";
import Modal from "../modal/modal";

import { $util, $const } from "../../helper";

import "./stylesheets/createTeamFormBBS.scss";

const FormItem = Form.Item;
const Option = Select.Option;

@inject("languageStore", "commonStore", "gameStore", "teamStore", "authStore")
@observer
@withRouter
class CreateTeam extends React.Component {
  state = {
    chinaArea: [],
    submitIsLoading: false,
    showCheckModal: false
  };

  componentDidMount() {
    this.setState({
      chinaArea: this.props.commonStore.pca
    });
  }

  handleSubmit = e => {
    e.preventDefault();
    this.setState({
      showCheckModal: true
    });
  };

  handleFetch = () => {
    this.setState({
      submitIsLoading: true,
      showCheckModal: false
    });
    if (!this.props.form.getFieldValue("inviteCode")) {
      this.props.form.setFieldsValue({
        inviteCode: $util.makeInviteCode()
      });
    }
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        try {
          const res = await agent.Teams.create({
            input: {
              attributes: {
                inviteCode: values.inviteCode,
                // 代表学校id
                collegeId: values.collegeId,
                // 学校所在地区，固定为空
                district: "",
                // 学校简称，固定为空
                collegeAbbreviation: "",
                // 学校名称，联队将学校名字用&拼接
                collegeName: values.delegateSchools ? values.delegateSchools.join("&") : "",
                // 校徽，固定为空
                collegeBadge: "",
                // 比赛id
                geventId: values.geventId,
                // 战队名
                name: values.name,
                // 战队类型
                teamType: values.teamType,
                // 收件地址
                consigneeAddress: values.consigneeAddress,
                // 收件人
                consigneeName: values.consigneeName,
                // 收件人联系方式
                consigneePhone: `${values.prefix.toString().indexOf("+") > -1 ? "" : "+"}${
                  values.prefix
                } ${values.consigneePhone}`,
                // 收件地址国家code
                consigneeCountryCode: values.area[0] ? values.area[0] : "",
                // 收件地址省份code
                consigneeProvinceCode: values.area[1] ? values.area[1] : "",
                // 收件地址城市code
                consigneeCityCode: values.area[2] ? values.area[2] : "",
                // 收件地址地区code
                consigneeDistrictCode: values.area[3] ? values.area[3] : "",
                nameEn: values.nameEn,
                // 介绍链接
                campusOrganization: "",
                introductionLink: "",
                // 战队口号
                teamSlogan: values.teamSlogan,
                // 论坛战队的id
                bbsTeamId: this.props.selectedBBSTeam.id
              }
            }
          });
          if (
            res &&
            res.data &&
            res.data.createGteam &&
            res.data.createGteam.gteam &&
            res.data.createGteam.gteam.id
          ) {
            const teamId = res.data.createGteam.gteam.id;
            const teamInfoRes = await agent.Teams.getTeamInfoById({
              variables: {
                id: teamId
              }
            });
            if (teamInfoRes && teamInfoRes.data && teamInfoRes.data.team) {
              const teamInfo = teamInfoRes.data.team;

              // 创建成功直接锁定当前队伍
              await agent.Teams.lockTeam({
                variables: {
                  input: {
                    id: teamId
                  }
                }
              });

              // 没有报名则报名
              const myFlow = $util.getTeamFlow(teamInfo);
              await this.props.gameStore.registration({
                variables: {
                  input: {
                    attributes: {
                      eventId: values.geventId,
                      sourceType: $const.SOURCE_TYPE.TEAM,
                      sourceId: teamId,
                      flowId: myFlow.id
                    }
                  }
                }
              });

              this.props.history.push(`/team-apply/${teamId}`);
            }
          }

          this.setState({
            submitIsLoading: false
          });
        } catch (error) {
          this.setState({
            submitIsLoading: false
          });
          message.error(
            this.props.languageStore.lang === "zh"
              ? "创建失败，请稍后重试。"
              : "Failed to create, please try again later.",
            3
          );
        }
      } else {
        this.setState({
          submitIsLoading: false
        });
      }
    });
  };

  checkTeamName = (rule, value, callback) => {
    if (value) {
      value = value.trim();
      if (value.length < 1) {
        callback(<Language resource="INVALID_CHAR" />);
      }
      if ($util.countWordsLength(value) > 16) {
        callback(<Language resource="CHAR_LIMIT" />);
      }
      if (
        value.indexOf("队") > -1 ||
        value.indexOf("*") > -1 ||
        value.indexOf("/") > -1 ||
        value.indexOf("-") > -1 ||
        value.indexOf("+") > -1
      ) {
        callback(<Language resource="ILLEG_CHAR" />);
      }
    }
    callback();
  };

  validatePhone = (rule, value, callback) => {
    const prefix = this.props.form.getFieldValue("prefix");
    // if (!value) return callback(<Language resource="EMPTY_PHONE" /> )
    if (value) {
      if (prefix.toString() === "86" || prefix.toString() === "+86") {
        if (!$const.CHINA_PHONE.test(value)) callback(<Language resource="WRONG_PHONE" />);
        callback();
      } else {
        // 国际号码只做最短、最长校验
        if (!$const.FOREIGN_PHONE.test(value)) callback(<Language resource="WRONG_PHONE" />);
        callback();
      }
    }
    callback();
  };

  areaOnChange = value => {
    this.props.form.setFieldsValue({
      consigneeDistrictCode: value[3] ? value[3] : "",
      consigneeCityCode: value[2] ? value[2] : "",
      consigneeProvinceCode: value[1] ? value[1] : "",
      consigneeCountryCode: value[0] ? value[0] : ""
    });
  };

  handleTeamTypeChange = value => {
    const delegateSchoolsO = this.props.form.getFieldValue("delegateSchools");
    this.props.form.setFieldsValue({
      delegateSchools: value === 1 ? delegateSchoolsO : delegateSchoolsO.slice(0, 1)
    });
  };

  closeModal = () => {
    this.setState({
      showCheckModal: false
    });
  };

  render() {
    const lang = this.props.languageStore.lang;
    const selectedBBSTeam = this.props.selectedBBSTeam;
    const userInfo = this.props.authStore.user;
    const { getFieldDecorator } = this.props.form;
    // 当前比赛的赛事类型id
    const curGameCategoryId = `${this.props.gameStore.selectedGame.attributes.category_id}`;
    // 是否需要填写战队口号
    const showTeamSloganInput = this.props.gameStore.showTeamSloganGameCategoryId.includes(
      curGameCategoryId
    );

    const contactPhone = userInfo.phone_number;

    let phoneNumPrefix = "";
    let contactPhoneAffix = "";

    contactPhone.includes(" ") && ([phoneNumPrefix, contactPhoneAffix] = contactPhone.split(" "));

    const prefixSelector = getFieldDecorator("prefix", {
      initialValue: phoneNumPrefix
    })(
      <Select style={{ width: 100 }}>
        {$const.PHONE_PREFIX.map(item => {
          return <Option key={item} value={item}>{`+${item}`}</Option>;
        })}
      </Select>
    );

    const delegateSchoolsInitValue = selectedBBSTeam.colleges.map(item => item.collegeName);

    // 国家
    let options = $const.COUNTRIES[lang];
    if (lang === "zh") {
      options[0].children = this.state.chinaArea;
    }

    return (
      <div className="create-team-form">
        <Form onSubmit={this.handleSubmit} className="create-team-form">
          <div className="create-team">
            <div className="title">
              <Language resource="CONFIRM_REGISTRATION_INFO" />
            </div>
            <FormItem className="team-name-collegeId" style={{ display: "none" }}>
              {getFieldDecorator("collegeId", {})(<Input />)}
            </FormItem>
            <FormItem style={{ display: "none" }}>
              {getFieldDecorator("consigneeCountryCode", {})(<Input />)}
            </FormItem>
            <FormItem style={{ display: "none" }}>
              {getFieldDecorator("consigneeProvinceCode", {})(<Input />)}
            </FormItem>
            <FormItem style={{ display: "none" }}>
              {getFieldDecorator("consigneeCityCode", {})(<Input />)}
            </FormItem>
            <FormItem style={{ display: "none" }}>
              {getFieldDecorator("consigneeDistrictCode", {})(<Input />)}
            </FormItem>
            {/* 战队中文名 */}
            <FormItem
              className="team-name-item"
              label={<Language resource="TEAM_NAME" />}
              extra={<Language resource="TEAM_NAME_TIP" />}
            >
              {getFieldDecorator("name", {
                rules: [
                  {
                    required: true,
                    message: <Language resource="PLEASE_ENTER_TEAM_NAME" />
                  },
                  {
                    validator: this.checkTeamName
                  }
                ],
                initialValue: selectedBBSTeam.nameZh
              })(<Input disabled={!!selectedBBSTeam.nameZh} />)}
            </FormItem>
            {/* 战队英文名 */}
            {this.props.languageStore.lang === "zh" && (
              <FormItem
                className="team-name-item"
                label={<Language resource="TEAM_NAME_EN" />}
                extra={<Language resource="TEAM_NAME_EN_TIP" />}
              >
                {getFieldDecorator("nameEn", {
                  rules: [
                    {
                      required: true,
                      message: <Language resource="PLEASE_ENTER_TEAM_NAME_EN" />
                    },
                    {
                      validator: this.checkTeamName
                    }
                  ],
                  initialValue: selectedBBSTeam.nameEn
                })(<Input disabled={!!selectedBBSTeam.nameEn} />)}
              </FormItem>
            )}
            {/* 战队类型 */}
            <FormItem className="team-type-item">
              {getFieldDecorator("teamType", {
                rules: [{ required: true }],
                // 论坛那边1代表战队2代表联队，报名系统这里要减一
                initialValue: selectedBBSTeam.teamType - 1,
                onChange: this.handleTeamTypeChange
              })(
                <Select disabled={!!selectedBBSTeam.teamType}>
                  <Option value={$const.TEAM_TYPE.TEAM}>
                    <Language resource="TEAM" />
                  </Option>
                  <Option value={$const.TEAM_TYPE.CONSORTIUM}>
                    <Language resource="CONSORTIUM" />
                  </Option>
                </Select>
              )}
            </FormItem>
            {/* 参赛项目 */}
            <FormItem label={<Language resource="ENTRY_PROJECT" />}>
              {getFieldDecorator("geventId", {
                rules: [
                  {
                    required: true,
                    message: <Language resource="ENTRY_PROJECT_EMPTY_TIP" />
                  }
                ]
              })(
                <Select disabled>
                  <Option
                    key={this.props.gameStore.selectedGame.id}
                    value={this.props.gameStore.selectedGame.id}
                  >
                    {this.props.gameStore.selectedGame.attributes.title}
                  </Option>
                </Select>
              )}
            </FormItem>
            <FormItem className="team-name-collegeId" style={{ display: "none" }}>
              {getFieldDecorator("collegeName", {})(<Input />)}
            </FormItem>
            <FormItem className="team-name-collegeId" style={{ display: "none" }}>
              {getFieldDecorator("delegateSchools", {
                initialValue: delegateSchoolsInitValue
              })(<Input />)}
            </FormItem>
            {/* 代表学校 */}
            <FormItem
              label={<Language resource="TEAM_SCHOOL" />}
              className="create-team-form__form-item-school"
            >
              <div style={{ width: 350 }}>
                {delegateSchoolsInitValue.map((item, index) => (
                  <Input key={index + 1} value={item} disabled />
                ))}
              </div>
            </FormItem>
            {/* 战队口号 */}
            {showTeamSloganInput ? (
              <FormItem
                className="team-name-item"
                label={<Language resource="TEAM_SLOGAN" />}
                extra={<Language resource="TEAM_SLOGAN_TIPS" />}
              >
                {getFieldDecorator("teamSlogan", {
                  rules: [{ required: false }],
                  initialValue: selectedBBSTeam.teamSlogan
                })(<Input />)}
              </FormItem>
            ) : null}
            {/* 收件人 */}
            <FormItem className="addressee" label={<Language resource="ADDRESSEE" />}>
              {getFieldDecorator("consigneeName", {
                rules: [
                  {
                    required: true,
                    message: <Language resource="EMPTY_RECIPIENT" />
                  }
                ],
                initialValue: userInfo.nickname
              })(<Input />)}
            </FormItem>
            {/* 联系方式 */}
            <FormItem label={<Language resource="ADDRESSEE_PHONE" />}>
              {getFieldDecorator("consigneePhone", {
                rules: [
                  {
                    required: true,
                    message: <Language resource="EMPTY_PHONE" />
                  },
                  {
                    validator: this.validatePhone
                  }
                ],
                initialValue: contactPhoneAffix
              })(<Input addonBefore={prefixSelector} />)}
            </FormItem>
            {/* 收件地址 */}
            <FormItem label={<Language resource="ADDRESSEE_ADRESS" />}>
              {getFieldDecorator("area", {
                rules: [
                  {
                    required: true,
                    message: <Language resource="EMPTY_RECIPIENT" />
                  }
                ]
              })(
                <Cascader
                  placeholder={this.props.languageStore.getResource(lang, "AREA")}
                  options={options}
                  onChange={this.areaOnChange}
                />
              )}
            </FormItem>

            <FormItem className="emtpy-school-label" extra={<Language resource="ADDRESSEE_TIP" />}>
              {getFieldDecorator("consigneeAddress", {
                rules: [
                  {
                    required: true,
                    message: <Language resource="EMPTY_ADDRESS" />
                  }
                ]
              })(<Input />)}
            </FormItem>

            <FormItem className="submit">
              <Button type="primary" htmlType="submit" loading={this.state.submitIsLoading}>
                <Language resource="CONFIRM" />
              </Button>
            </FormItem>
          </div>
        </Form>
        <Modal
          title={<Language resource="APPLY_GAME" />}
          state={this.state.showCheckModal}
          close={this.closeModal}
          className="create-team-formBBS__modal-box"
        >
          <div className="create-team-formBBS__modal--info">
            <Language resource="CREATE_TEAM_BBS_TIPS1" />
            <Language
              resource="CREATE_TEAM_BBS_TIPS2"
              className="create-team-formBBS__modal--highLight"
            />
            <Language resource="CREATE_TEAM_BBS_TIPS3" />
          </div>

          <Button
            className="create-team-formBBS__modal-btn"
            type="primary"
            htmlType="submit"
            onClick={this.handleFetch}
          >
            <Language resource="CONFIRM" />
          </Button>
        </Modal>
      </div>
    );
  }
}

const CreateTeamFormFromBBS = Form.create({
  mapPropsToFields(props) {
    return {
      geventId: Form.createFormField({
        value: props.eventId
      })
    };
  }
})(CreateTeam);

export default CreateTeamFormFromBBS;



// WEBPACK FOOTER //
// ./src/components/createTeam/createTeamFormFromBBS.js